<template>
    <div></div>
</template>

<script>
export default {
    data() {
        return {
            id: this.$route.params.id,
        }
    },
    created() {
        // 产品列表
        if (this.id == 5 || this.id == 16) {
            this.$router.push('/product')
        } else if (
            this.id == '24.html' ||
            this.id == '20.html' ||
            this.id == '21.html'
        ) {
            // 产品详情--自动化系统
            if (this.id == '24.html') {
                this.id = 'zdhxt'
                // 产品详情--能源管理系统
            } else if (this.id == '20.html') {
                this.id = 'nyglxt'
            } else if (this.id == '21.html') {
                //  // 产品详情--数字化系统
                this.id = 'szhxt'
            }
            // this.$router.push('/productDetail/' + this.id)
            // 精品案例列表
        } else if (this.id == 12 || this.id == 17) {
            this.$router.push('/case')
        } else if (
            this.id == '71.html' ||
            this.id == '69.html' ||
            this.id == '68.html' ||
            this.id == '26.html' ||
            this.id == '25.html' ||
            this.id == '27.html'
        ) {
            // 精品案例详情--江华城
            if (this.id == '71.html') {
                this.id = 'jhc'
                // 精品案例详情--中牧实业
            } else if (this.id == '69.html') {
                this.id = 'zmsy'
            } else if (this.id == '68.html') {
                // 精品案例详情--中农威特
                this.id = 'znwt'
            } else if (this.id == '26.html') {
                // 精品案例详情--美光半导体
                this.id = 'mgbdt'
            } else if (this.id == '25.html') {
                // 精品案例详情--兰州生物
                this.id = 'lzsw'
            } else if (this.id == '27.html') {
                // 精品案例详情--智能化系统
                this.id = 'znhxt'
            }
            this.$router.push('/caseDetail/' + this.id)
            // 新闻中心
        } else if (this.id == 13 || this.id == 14 || this.id == 15) {
            this.$router.push('/newsList/' + this.id)
        } else if (
            this.id == '83.html' ||
            this.id == '82.html' ||
            this.id == '81.html' ||
            this.id == '79.html' ||
            this.id == '80.html'
        ) {
            // 新闻详情--BIM
            if (this.id == '83.html') {
                this.id = '77530e7c-2a0a-4f06-9015-08a37b683785'
                // 新闻详情--可视化
            } else if (this.id == '82.html') {
                this.id = '17c700db-742d-47cf-af8d-d6a8d926088c'
            } else if (this.id == '81.html') {
                // 新闻详情--盘点工控行业几大技术
                this.id = '10769e3a-dd11-40ac-bdff-cd03c570c723'
            } else if (this.id == '79.html') {
                // 新闻详情--带你了解数字化工厂
                this.id = '8eb3d286-bf87-4249-85ca-aecab39a1f7e'
            } else if (this.id == '80.html') {
                // 新闻详情--常见空调系统分类
                this.id = 'b9e7fdc6-8656-4bb3-b24b-18d5e48ad5ce'
            }
            this.$router.push('/newsDetail/' + this.id + '/14')
        } else if (
            this.id == 1 ||
            this.id == 2 ||
            this.id == 3 ||
            this.id == 4 ||
            this.id == '47.html' ||
            this.id == '65.html' ||
            this.id == -1 ||
            this.id == '74.html' ||
            this.id == '64.html' ||
            this.id == '51.html' ||
            this.id == '78.html' ||
            this.id == '76.html' ||
            this.id == '48.html' ||
            this.id == '49.html' ||
            this.id == '73.html' ||
            this.id == '67.html' ||
            this.id == '77.html' ||
            this.id == '72.html' ||
            this.id == '52.html' ||
            this.id == '66.html' ||
            this.id == '75.html'
        ) {
            // 资质荣誉
            if (
                this.id == '47.html' ||
                this.id == -1 ||
                this.id == '78.html' ||
                this.id == '48.html' ||
                this.id == '49.html' ||
                this.id == '77.html'
            ) {
                this.id = 1
                // 软件著作权
            } else if (
                this.id == '65.html' ||
                this.id == '64.html' ||
                this.id == '67.html' ||
                this.id == '66.html'
            ) {
                this.id = 3
                // 质量管理体系认证
            } else if (
                this.id == '74.html' ||
                this.id == '51.html' ||
                this.id == '76.html' ||
                this.id == '73.html' ||
                this.id == '72.html' ||
                this.id == '52.html' ||
                this.id == '75.html'
            ) {
                this.id = 2
            }
            this.$router.push('/certificate/' + this.id)
        }
    },
}
</script>
